import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RepoService } from './repo.service';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const repoService = inject(RepoService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // VERY IMPORTANT: Wait for Firebase Auth to initialize before proceeding!
  // If we don't wait, the Guard evaluates immediately on route load where user is undefined, 
  // kicking the user out back to the root before Firebase can even say "they are logged in".
  await authService.authInitialized;

  const requiredAccess = route.data['access'] as string;

  if (repoService.adminPortalUser()) {
    if (
      repoService.adminPortalUser().access.includes(requiredAccess) ||
      repoService.adminPortalUser().roles?.includes('admin') ||
      (requiredAccess === 'RFID price' && repoService.adminPortalUser().access.includes('Charging prices'))
    ) {
      return true;
    } else {
      console.warn(`[AuthGuard (services)] No access to ${requiredAccess}. Navigating to noAccess.`);
      router.navigate(['/main/noAccess']);
      return false;
    }
  } else {
    console.warn(`[AuthGuard (services)] No user found. Navigating to root from ${state.url}.`);
    console.trace("[AuthGuard (services)] Trace:");
    router.navigate(['/']);
    return false;
  }
};
